import styled from 'styled-components';
import { Checkbox, tombac } from 'tombac';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const StyledCheckbox = styled(Checkbox).withConfig({
  displayName: "IconCheckbox__StyledCheckbox"
})(["[class^='Checkbox__Label']{align-items:center;gap:", ";display:inline-flex;vertical-align:middle;}[class^='Checkbox__StyledCheckbox']{vertical-align:middle;}"], tombac.space(1));
export const IconCheckbox = _ref => {
  let {
    icon,
    label,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(StyledCheckbox, {
    label: /*#__PURE__*/_jsxs(_Fragment, {
      children: [icon, " ", label]
    }),
    ...props,
    "data-sentry-element": "StyledCheckbox",
    "data-sentry-component": "IconCheckbox",
    "data-sentry-source-file": "IconCheckbox.tsx"
  });
};